import { render, staticRenderFns } from "./EtabOrias.vue?vue&type=template&id=4437de89"
import script from "./EtabOrias.vue?vue&type=script&lang=js"
export * from "./EtabOrias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports